import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col,
  Table,
  ButtonGroup,
  Button,
  Alert
} from 'react-bootstrap';
import Form from '../../common/forms/dynamic-form';
import FormInput from '../../common/forms/form-input';
import SubscriptionPanel from './single-panel';
import { connect } from 'react-redux';
import { formatDateTime } from '../../utils/format';
import i18n from 'kodyl-js/i18n/react';
import {
  cancelSubscription,
  unsubscribeManual,
  unsubscribeReason
} from '../../redux/modules/subscriptions';
import { Link } from 'react-router';
import AfterUnsubscription from './after-unsubscription';

const FOUND_DWELLING = 'FOUND_DWELLING';
const FOUND_NO_DWELLING = 'FOUND_NO_DWELLING';

@connect(
  ({ auth: { user }, subscriptions }) => ({ user, subscriptions }),
  { cancelSubscription, unsubscribeManual, unsubscribeReason }
)
@i18n
class UnsubscriptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {},
      success: false,
      foundDwelling: false,
      receipt: null,
      uuid: null,
      error: false,
      unsubscribing: null
    };
  }

  handleUnsubscriptionResponse = action => {
    if (action && action.payload && action.payload.status === 'OK') {
      this.setState({
        success: true,
        uuid: action.payload.data.uuid,
        values: action.payload.data,
        receipt: action.payload.data.reason ? action.payload.data : null,
        subscription: null
      });
    }
    if (/FAIL/.test(action.type)) {
      this.setState({ error: true });
    }
    return action;
  };

  handleSubmit = () => {
    const {
      values,
      values: { reason },
      uuid
    } = this.state;
    this.setState({ error: false });

    if (uuid && reason) {
      this.props
        .unsubscribeReason({ reason, uuid })
        .then(this.handleUnsubscriptionResponse);
    }

    if (!uuid) {
      this.props
        .unsubscribeManual(values)
        .then(this.handleUnsubscriptionResponse);
    }
  };

  handleChange = ev => {
    const { target } = ev;
    const { type, name } = target;
    const value = type === 'checkbox' ? target.checked : target.value;

    const { values } = this.state;

    this.setState(
      {
        values: {
          ...values,
          [/pre-/.test(name) ? 'reason' : name]: /pre-/.test(name)
            ? { ...values.reason, [name.replace('pre-', '')]: value }
            : value
        }
      },
      () => {
        if (name !== 'pre-notFoundDwelling' && /pre-/.test(name)) {
          this.handleSubmit();
        }
      }
    );
  };

  openSurvey = val => {
    this.setState({ foundDwelling: val });
  };

  setSubscription = subscr => {
    this.setState({ unsubscribing: subscr });
  };

  render() {
    const { subscriptions, user } = this.props;
    const {
      success,
      receipt,
      foundDwelling,
      error,
      values,
      unsubscribing
    } = this.state;

    return (
      <Grid>
        <h2>{this.i18n('Unsubscribe')}</h2>

        <Row>
          <Col xs={12}>
            {!subscriptions.subscriber ? (
              <p>
                Udfyld formularen herunder for at afmelde din Boligsøgerannonce
                på Boligninja.dk.
              </p>
            ) : null}
            {!subscriptions.subscriber ? (
              <p>
                Når din afmelding er modtaget, vil du her på siden modtage en
                kvittering for din afmelding. Det er meget vigtigt, at du
                printer eller gemmer en kopi af kvitteringen/oplysningerne, da
                det er din garanti for at afmeldingen er modtaget og gældende
                fra det oplyste tidspunkt.
              </p>
            ) : null}
            {!user || !subscriptions || !subscriptions.subscriber ? (
              <p>
                Da du{' '}
                {!user
                  ? 'ikke er logget ind'
                  : 'ikke har noget abonnement på din profil'}
                , kan vi ikke knytte din afmelding til et abonnement, og det
                kræver derfor en manuel process at gennemføre afmeldingen. Der
                er derfor en risiko, at din Boligsøgerannonce når at blive
                fornyet, inden vi kan gennemføre afmeldingen - det gælder
                specielt uden for normal arbejdstid. Det er dog altid
                tidspunktet som oplyses i din afmeldingskvittering der er
                gældende, og skulle der blive trukket på dit kort efter dette
                tidspunkt, så tilbagefører vi automatisk beløbet i forbindelse
                med, at din afmelding behandles.
              </p>
            ) : null}
            {!user && !success ? (
              <Alert bsStyle="warning">
                <p>
                  {`${this
                    .i18n(`Log-ind for at gøre afmeldingsprocessen hurtigere!
                  Når du er logget ind behandles din afmelding automatisk. Hvis du ikke er logget ind, forsinkes afmeldingen af, at den skal håndteres manuelt.`)} `}
                  <Link to="/login?next=/profile/subscription">
                    {this.i18n('Login')}
                  </Link>
                </p>
              </Alert>
            ) : null}
            <hr />
          </Col>
        </Row>
        <Row>
          {subscriptions && subscriptions.subscriber ? (
            unsubscribing ? (
              <AfterUnsubscription
                subscription={unsubscribing}
                setSubscription={this.setSubscription}
              />
            ) : (
              <Col sm={6}>
                {subscriptions.list.map(subscription => (
                  <SubscriptionPanel
                    key={subscription._id}
                    subscription={subscription}
                    setSubscription={this.setSubscription}
                  />
                ))}
              </Col>
            )
          ) : !receipt ? (
            <Col sm={9}>
              {values.uuid ? (
                <p style={{ fontStyle: 'italic' }}>
                  {this.i18n(
                    'Din anmodning er nu oprettet og vi mangler kun de sidste oplysninger fra dig.'
                  )}
                </p>
              ) : null}
              <Form
                onSubmit={this.handleSubmit}
                horizontal
                handleChange={this.handleChange}
                submitTxt={this.i18n('Unsubscribe')}
              >
                {values.uuid ? (
                  <div className="form-group">
                    <label className="control-label col-md-4">
                      {this.i18n('Id')}
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        defaultValue={values.uuid}
                        disabled
                      />
                    </div>
                  </div>
                ) : null}
                <FormInput
                  controlId="formHorizontalEmail"
                  name="email"
                  labelSize={4}
                  label={this.i18n('Email address')}
                  type="email"
                  required
                  disabled={values.uuid && values.email}
                />
                <FormInput
                  controlId="formHorizontalName"
                  name="name"
                  labelSize={4}
                  label={this.i18n('Name')}
                  type="text"
                  required
                  disabled={values.uuid && values.name}
                />
                <FormInput
                  controlId="formHorizontalPhone"
                  name="phone"
                  labelSize={4}
                  label={this.i18n('Phone')}
                  type="text"
                  required
                  disabled={values.uuid && values.phone}
                />
                <FormInput
                  controlId="formHorizontalOrderno"
                  name="orderno"
                  labelSize={4}
                  label={this.i18n('Order number')}
                  type="text"
                  disabled={values.uuid && values.orderno}
                />
                <FormInput
                  controlId="formHorizontalMessage"
                  name="message"
                  labelSize={4}
                  label={this.i18n('Message')}
                  type="textarea"
                  disabled={values.uuid && values.phone}
                  componentClass="textarea"
                />
                {success ? (
                  <div>
                    <Col sm={9} smOffset={3} className="form-button-group">
                      <label type="noop" className="sm-offset-3">
                        Afmelder du, fordi du har fundet en bolig
                      </label>
                    </Col>
                    <Col
                      type="noop"
                      sm={9}
                      smOffset={3}
                      className="form-button-group"
                    >
                      <ButtonGroup
                        noop
                        className="sm-offset-1"
                        type="noop"
                        style={{ marginBottom: 15 }}
                      >
                        <Button
                          type="button"
                          onClick={() => this.openSurvey(FOUND_DWELLING)}
                        >
                          Ja
                        </Button>
                        <Button
                          type="button"
                          onClick={() => this.openSurvey(FOUND_NO_DWELLING)}
                        >
                          Nej
                        </Button>
                      </ButtonGroup>
                    </Col>
                    {foundDwelling === FOUND_DWELLING ? (
                      <div>
                        <Col smOffset={3}>
                          <strong>Hvor fandt du boligen?</strong>
                        </Col>
                        <FormInput
                          labelSize={4}
                          label={this.i18n('Boligninja')}
                          name="pre-foundDwellingThroughBoligninja"
                          type="radio"
                          onChange={this.handleChange}
                        />
                        <FormInput
                          labelSize={4}
                          label={this.i18n('Other dwelling portal')}
                          name="pre-foundDwellingTroughOtherPortal"
                          type="radio"
                          onChange={this.handleChange}
                        />
                        <FormInput
                          labelSize={4}
                          label={this.i18n('Facebook')}
                          name="pre-foundDwellingThroughfacebook"
                          type="radio"
                          onChange={this.handleChange}
                        />
                        <FormInput
                          labelSize={4}
                          label={this.i18n('Through friends')}
                          type="radio"
                          onChange={this.handleChange}
                        />
                        <FormInput
                          labelSize={4}
                          label={this.i18n('Other')}
                          type="radio"
                          name="pre-foundDwellingOtherWay"
                          onChange={this.handleChange}
                        />
                      </div>
                    ) : null}
                    {foundDwelling === FOUND_NO_DWELLING ? (
                      <FormInput
                        labelSize={3}
                        label={this.i18n('Årsag')}
                        name="pre-notFoundDwelling"
                        onChange={this.handleChange}
                        required
                        type="textarea"
                        componentClass="textarea"
                      />
                    ) : null}
                  </div>
                ) : null}
                {error ? (
                  <Alert bsStyle="danger">
                    {this.i18n(
                      'Oops! Something went wrong. Please try again or reach out to our customer support.'
                    )}
                  </Alert>
                ) : null}
              </Form>
            </Col>
          ) : (
            <Col xs={12}>
              <div className="alert alert-success" role="alert">
                {this.i18n('Din Boligsøgerannonce er nu afmeldt')}
              </div>
              <p>
                Din afmelding er modtaget, men vi anbefaler, at du printer eller
                gemmer en kopi af denne side. Det er din garanti for, at
                afmeldingen er modtaget og gældende fra det oplyste tidspunkt.
              </p>

              <Table responsive striped>
                <tbody>
                  <tr>
                    <th>{this.i18n('ID')}</th>
                    <td>{receipt.uuid}</td>
                  </tr>
                  <tr>
                    <th>{this.i18n('Tidspunkt')}</th>
                    <td>{formatDateTime(receipt.timestamp)}</td>
                  </tr>
                  <tr>
                    <th>{this.i18n('Name')}</th>
                    <td>{receipt.name}</td>
                  </tr>
                  <tr>
                    <th>{this.i18n('Email address')}</th>
                    <td>{receipt.email}</td>
                  </tr>
                  <tr>
                    <th>{this.i18n('Phone')}</th>
                    <td>{receipt.phone}</td>
                  </tr>
                  <tr>
                    <th>{this.i18n('Ordrenummer')}</th>
                    <td>{receipt.orderno}</td>
                  </tr>
                  <tr>
                    <th>{this.i18n('Besked')}</th>
                    <td>{receipt.message}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          )}

          <Col xs={12}>
            {!subscriptions.subscriber ? (
              <p
                style={{
                  fontSize: '0.9em',
                  fontStyle: 'italic',
                  paddingTop: 15
                }}
              >
                Hvis du oplever problemer med afmelding ovenfor, kan du afmelde
                ved at sende et brev eller en email til afmeld@boligninja.dk.
                Vær dog opmærksom på, at afmelding via brev eller email kan tage
                længere tid, hvorfor vi anbefaler at der afmeldes ovenfor, hvis
                muligt.
              </p>
            ) : null}
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default UnsubscriptionForm;
